<div class="send-to-insco-title subtitle-1" #inscoTitle [class.add-width]="inscoTitle?.offsetWidth >= 200">
  Send to
  <h6 class="insco-name">{{ recipient }}</h6>
</div>
<mat-tab-group
  dynamicHeight
  animationDuration="0ms"
  class="charcoal-tab"
  [(selectedIndex)]="selectedTabIndex"
  [class.extra-margin]="inscoTitle?.offsetWidth >= 200"
  [class.orange-tab]="jobService.displayWarningQuoteTab() && activatedTab === 'quote'"
  (selectedTabChange)="activatedTab = $event?.tab?.textLabel"
  #tabGroup>
  @if (unSubmittedDiary) {
    <mat-tab [label]="'diary'">
      <ng-template mat-tab-label>
        <span class="subtitle-2 span-label-for-tab">
          @if (appAddDairy?.diaryForm?.status === 'INVALID') {
            <mat-icon
              class="text-red!"
              [matTooltip]="appAddDairy?.diaryForm?.status === 'VALID' ? null : 'Complete to send'">
              info
            </mat-icon>
          }
          Diary
        </span>
      </ng-template>
      <div class="mt-[21px]">
        <app-add-diary
          #appAddDairy
          (disableSendButton)="validateSendJob.emit()"
          (refreshJobViewer)="refresh.emit()"
          [diary]="unSubmittedDiary">
        </app-add-diary>
      </div>
    </mat-tab>
  }

  @if (unSubmittedPhotos?.length) {
    <mat-tab [label]="'photo'">
      <ng-template mat-tab-label>
        <span class="subtitle-2 span-label-for-tab">
          {{ unSubmittedPhotos?.length > 1 ? 'Photos' : 'Photo' }}
        </span>
      </ng-template>
      <div class="mt-[21px]">
        <app-gallery-curtain
          (refreshJobViewer)="refresh.emit()"
          (updateSelectedPhoto)="updateSelectedPhoto.emit($event)"
          [job]="job"
          [photos]="unSubmittedPhotos"
          [quote]="!unSubmittedQuote">
        </app-gallery-curtain>
      </div>
    </mat-tab>
  }

  @if (unSubmittedDocs?.length) {
    <mat-tab [label]="'document'">
      <ng-template mat-tab-label>
        <span class="subtitle-2 span-label-for-tab">
          {{ unSubmittedDocs?.length > 1 ? 'Documents' : 'Document' }}
        </span>
      </ng-template>
      <div class="mt-[21px]">
        <app-documents-curtain
          (refreshJobViewer)="refresh.emit()"
          [job]="job"
          [docs]="unSubmittedDocs"
          [blockExpansion]="true">
        </app-documents-curtain>
      </div>
    </mat-tab>
  }

  @if (unSubmittedCustomerFeedback) {
    <mat-tab [label]="'customerFeedback'">
      <ng-template mat-tab-label>
        <span class="subtitle-2 span-label-for-tab">
          @if (appAddCustomerFeedback?.customerFeedbackForm?.status === 'INVALID') {
            <mat-icon
              class="text-red!"
              [matTooltip]="
                appAddCustomerFeedback?.customerFeedbackForm?.status === 'VALID' ? null : 'Complete to send'
              "
              >info</mat-icon
            >
          }
          Customer Feedback
        </span>
      </ng-template>
      <div class="mt-[21px]">
        <app-add-customer-feedback
          #appAddCustomerFeedback
          [customerFeedback]="unSubmittedCustomerFeedback"
          (disableSendButton)="validateSendJob.emit(); disableSendButton.emit($event)"
          (refreshJobViewer)="refresh.emit()">
        </app-add-customer-feedback>
      </div>
    </mat-tab>
  }

  @if (unSubmittedCustomerContact) {
    <mat-tab [label]="'customerContacts'">
      <ng-template mat-tab-label>
        <span class="subtitle-2 span-label-for-tab">
          @if (appAddCustomerContact?.customerContactedForm?.status === 'INVALID') {
            <mat-icon
              class="text-red!"
              [matTooltip]="
                appAddCustomerContact?.customerContactedForm?.status === 'VALID' ? null : 'Complete to send'
              "
              >info
            </mat-icon>
          }
          Customer Contact
        </span>
      </ng-template>
      <div class="mt-[21px]">
        <app-add-customer-contact
          #appAddCustomerContact
          [customerContact]="unSubmittedCustomerContact"
          [repairerSiteName]="job?.repairerSiteName"
          [ownerName]="ownerName"
          [timezone]="timezone"
          (disableSendButton)="validateSendJob.emit(); disableSendButton.emit($event)"
          (refreshJobViewer)="refresh.emit()">
        </app-add-customer-contact>
      </div>
    </mat-tab>
  }

  @if (unSubmittedPotentialBreachOfCode) {
    <mat-tab [label]="'codeOfPracticeBreaches'">
      <ng-template mat-tab-label>
        <span class="subtitle-2 span-label-for-tab">
          @if (appAddPotentialBreachCode?.potentialBreachOfCodeForm?.status === 'INVALID') {
            <mat-icon
              class="text-red!"
              [matTooltip]="
                appAddPotentialBreachCode?.potentialBreachOfCodeForm?.status === 'VALID' ? null : 'Complete to send'
              "
              >info
            </mat-icon>
          }
          Potential Breach of Code
        </span>
      </ng-template>
      <div class="mt-[21px]">
        <app-add-potential-breach-code
          #appAddPotentialBreachCode
          [potentialBreachOfCode]="unSubmittedPotentialBreachOfCode"
          (disableSendButton)="validateSendJob.emit(); disableSendButton.emit($event)"
          (refreshJobViewer)="refresh.emit()">
        </app-add-potential-breach-code>
      </div>
    </mat-tab>
  }

  @if (unSubmittedCustomerVulnerability) {
    <mat-tab [label]="'customerVulnerabilities'">
      <ng-template mat-tab-label>
        <span class="subtitle-2 span-label-for-tab">
          @if (appAddCustomerVulnerability?.customerVulnerabilityForm?.status === 'INVALID') {
            <mat-icon
              class="text-red!"
              [matTooltip]="
                appAddCustomerVulnerability?.customerVulnerabilityForm?.status === 'VALID' ? null : 'Complete to send'
              "
              >info
            </mat-icon>
          }
          Vulnerable Customer
        </span>
      </ng-template>
      <div class="mt-[21px]">
        <app-add-customer-vulnerability
          #appAddCustomerVulnerability
          [vulnerability]="unSubmittedCustomerVulnerability"
          [currentUser]="currentUser"
          (disableSendButton)="validateSendJob.emit()"
          (refreshJobViewer)="refresh.emit()">
        </app-add-customer-vulnerability>
      </div>
    </mat-tab>
  }

  @if (showSelfAuthorisationCurtain) {
    <mat-tab [label]="'selfAuthorise'">
      <ng-template mat-tab-label>
        <span class="subtitle-2 span-label-for-tab"> Self-Authorise </span>
      </ng-template>
      <div class="mt-[21px]">
        <app-self-authorise
          (refreshJobViewer)="refresh.emit()"
          (openPdfReport)="openPdfReport.emit('pre_authorized')"
          [jobId]="job?.jobId">
        </app-self-authorise>
      </div>
    </mat-tab>
  }

  @if (showBooking) {
    <mat-tab [label]="'inspectionBooking'">
      <ng-template mat-tab-label>
        <span class="subtitle-2 span-label-for-tab">
          @if (appBookingCurtain?.bookingForm?.status === 'INVALID') {
            <mat-icon
              class="text-red!"
              [matTooltip]="appBookingCurtain?.bookingForm?.status === 'VALID' ? null : 'Complete to send'"
              >info</mat-icon
            >
          }
          Inspection Booking
        </span>
      </ng-template>
      <div class="mt-[21px]">
        <app-booking
          #appBookingCurtain
          (disableSendButton)="validateSendJob.emit(); disableSendButton.emit(true)"
          (refreshJobViewer)="refresh.emit()"
          [hasQuote]="!!unSubmittedQuote"
          [job]="job"
          [timezone]="timezone"
          [onSite]="job?.onSiteInspection"
          [preselectedOption]="job?.bookingOption">
        </app-booking>
      </div>
    </mat-tab>
  }

  @if (unSubmittedInvoice) {
    <mat-tab [label]="'invoice'">
      <ng-template mat-tab-label>
        <span class="subtitle-2 span-label-for-tab">
          @if (appInvoiceCurtain?.invoiceForm?.status === 'INVALID') {
            <mat-icon
              class="text-red!"
              [matTooltip]="appInvoiceCurtain?.invoiceForm?.status === 'VALID' ? null : 'Complete to send'"
              >info</mat-icon
            >
          }
          Invoice {{ unSubmittedInvoice?.document?.invoiceNumber }}
        </span>
      </ng-template>
      <div class="mt-[21px]">
        <app-invoice-curtain
          #appInvoiceCurtain
          [isSentToInsurerTray]="expandCurtainInTray"
          (disableSendButton)="disableSendButton.emit($event || showValidationGuidance)"
          (refreshInvoice)="refresh.emit($event)"
          (synchronizeOwnerContribution)="synchronizeOwnerContribution.emit($event)"
          (validateField)="validateSendJob.emit($event)"
          [document]="unSubmittedInvoice"
          [lastExcessChangeTimestamp]="job?.lastExcessChangeTimestamp">
        </app-invoice-curtain>
      </div>
    </mat-tab>
  }
  @if (unSubmittedQuote) {
    <mat-tab [label]="'quote'">
      <ng-template mat-tab-label>
        <span class="subtitle-2 span-label-for-tab">
          @if (jobService.displayWarningQuoteTab()) {
            <mat-icon matTooltip="Quoting Conflict, Merge Or Replace To Send" class="size-18! text-18! text-orange!">
              warning
            </mat-icon>
          } @else if (
            !quoteCurtainEnableSendButton ||
            (unSubmittedQuote?.document?.manual && unSubmittedQuote?.document?.estTotal === 0)
          ) {
            <mat-icon
              class="text-red!"
              [matTooltip]="
                quoteCurtainEnableSendButton &&
                !(unSubmittedQuote?.document?.manual && unSubmittedQuote?.document?.estTotal === 0)
                  ? null
                  : 'Complete to send'
              ">
              info
            </mat-icon>
          }
          {{ unSubmittedQuote?.document?.original ? '' : 'Supplement ' }} Quote
        </span>
      </ng-template>
      <div class="mt-[21px]">
        @if (jobService.displayWarningQuoteTab()) {
          <section class="bg-orange text-white subtitle-2 rounded m-10 p-10 flex items-center justify-between gap-10">
            <div class="flex items-center gap-10">
              <mat-icon> warning </mat-icon>
              The previous quote has not been authorised yet. Please select to merge quotes or replace the previous
              quote completely (assessment results of the previous quote will be maintained if applicable).
            </div>
            <div class="flex items-center gap-10">
              <button matButton="filled" class="white-button subtitle-2" (click)="updateStrategyQuote('MERGE')">
                MERGE
              </button>
              <button matButton="filled" class="white-button subtitle-2" (click)="updateStrategyQuote('REPLACE')">
                REPLACE
              </button>
            </div>
          </section>
        }
        @if (jobService.displayWarningQuoteTab()) {
          <app-quote-curtain
            [document]="submittedQuoteNotAuthorised[0]"
            [editable]="false"
            [quotingSystemName]="job.quotingSystem?.companyName"
            [previousQuote]="true"
            [isSentToInsurerTray]="expandCurtainInTray">
          </app-quote-curtain>
        }
        <app-quote-curtain
          (disableSendButton)="disableSendButton.emit($event); quoteCurtainEnableSendButton = !$event"
          (refreshJobViewer)="refresh.emit($event)"
          (validateQuote)="validateSendJob.emit()"
          [document]="unSubmittedQuote"
          [editable]="job?.editable"
          [canBeReplacedOrMerged]="jobService.displayWarningQuoteTab()"
          [updateStrategy]="job?.updateStrategy"
          [quotingSystemName]="job.quotingSystem?.companyName"
          [isSentToInsurerTray]="expandCurtainInTray">
        </app-quote-curtain>
      </div>
    </mat-tab>
  }

  @if (unSubmittedQuote?.document?.original) {
    <mat-tab [label]="'vehicleLocation'">
      <ng-template mat-tab-label>
        <span class="subtitle-2 span-label-for-tab">
          @if (!job?.vehicleLocation) {
            <mat-icon class="text-red!" matTooltip="Complete to send">info</mat-icon>
          }
          Vehicle Location
        </span>
      </ng-template>
      <div class="mt-[21px]">
        <mat-card class="curtains">
          <mat-card-content>
            <h5 class="mb-16">Vehicle Location</h5>
            <p class="body-2 text-charcoal-50 mb-16">Please provide the current vehicle location, if known, to assist the assessor with scheduling the inspection.</p>
            <mat-form-field class="w-[300px]!">
              <mat-label>Vehicle Location</mat-label>
              <mat-select
                [value]="job?.vehicleLocation"
                (selectionChange)="onVehicleLocationChange($event.value)">
                @for (option of vehicleLocationOptions; track option.value) {
                  <mat-option [value]="option.value">{{ option.label }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </mat-card-content>
        </mat-card>
      </div>
    </mat-tab>
  }

  @if (noQuoteResponse) {
    <mat-tab [label]="'returnToAssessor'">
      <ng-template mat-tab-label>
        <span class="subtitle-2 span-label-for-tab">
          @if (appAddReturnNoQuote?.replyForm?.status === 'INVALID') {
            <mat-icon
              class="text-red!"
              [matTooltip]="appAddReturnNoQuote?.replyForm?.status === 'VALID' ? null : 'Complete to send'"
              >info</mat-icon
            >
          }
          Return to Assessor
        </span>
      </ng-template>
      <div class="mt-[21px]">
        <app-add-return-no-quote
          #appAddReturnNoQuote
          (refreshJobViewer)="refresh.emit($event)"
          [assessmentAction]="job?.noQuoteResponseAssessmentAction || noQuoteResponseAssessmentAction"
          [assessorAllocated]="job?.assessorAllocated"
          [displayRFA]="submittedQuoteNotAuthorised.length && submittedQuotes.length === 1"
          [displaySupplementRFA]="submittedQuoteNotAuthorised.length && submittedQuotes.length > 1"
          [hasQuotes]="hasQuotes"
          [jobId]="job?.jobId"
          [note]="job?.noQuoteResponseNote">
        </app-add-return-no-quote>
      </div>
    </mat-tab>
  }
</mat-tab-group>
